module.exports = __webpack_public_path__ + "img/document-download.901b7fc9.svg";